{
  "_comentario": [
    "Campos de la API de Vulcano que NUNCA entran a la base de datos.",
    "Luis lo pidió dos veces: 'no me interesa nada de lo de la plata'.",
    "Se descartan en la ingesta, antes de tocar la BD, y también dentro del",
    "raw_json del snapshot. Si Vulcano agrega un campo monetario nuevo,",
    "se añade a 'exactos' — no se toca el código.",
    "Ver PLAN.md §0 y CLAUDE.md regla 1."
  ],
  "exactos": [
    "valorTotalCobrar",
    "valorTotalPagar",
    "rentabilidad",
    "valorCobrar",
    "valorPagar",
    "costos",
    "conceptoCosto",
    "costoCobrar",
    "costoPagar"
  ],
  "_comentario_sospechosos": [
    "Regla defensiva: cualquier campo NO documentado cuyo nombre contenga",
    "alguno de estos fragmentos se descarta por defecto y se registra en el",
    "log del sync para revisión humana. Es la red de seguridad para cuando",
    "Vulcano agregue algo que nadie nos avisó."
  ],
  "sospechosos": [
    "valor",
    "costo",
    "precio",
    "tarifa",
    "flete",
    "rentabilidad",
    "utilidad",
    "anticipo",
    "saldo",
    "importe",
    "monto",
    "pago",
    "cobro",
    "iva",
    "descuento",
    "subtotal",
    "total"
  ],
  "_comentario_excepciones": [
    "Campos que SÍ se conservan aunque su nombre dispare la regla defensiva.",
    "Cada uno tiene que estar justificado: no son dinero.",
    "La comparación es exacta y sensible a mayúsculas."
  ],
  "excepciones": ["pesoTotal", "cantidadViajes", "totalPuntos"]
}
